import { LinkItem } from '../types';

export const appLinks: LinkItem[] = [
  {
    title: "Ember",
    description: "Comprehensive calculator toolset for combat robotics.",
    url: "https://ember.level5robotics.com",
    icon: "🔥",
    
  },
  {
    title: "Dex",
    description: "Fight histories, event results, and analytics for L5's combat robots.",
    url: "https://dex.level5robotics.com",
    icon: "📊",
    
  },
  {
    title: "SCAR Elo",
    description: "Public portal for displaying SCAR Elo ratings.",
    url: "https://elo.socalattackrobots.com",
    icon: "📈",
    isNew: true,
  },
  {
    title: "Blog",
    description: "Written content.",
    url: "https://trusted-traffic-70a.notion.site/c3d6c62442fd436fb9cc8dd5bbfd1b1c?v=e79940e8496c40bb98b0b569fd3cffbc&pvs=74",
    icon: "✍️"
  }
]; 